import React from 'react';
import './GlobalVariablesBar.css';

const GlobalVariablesBar = ({ globals, onUpdate, defaults }) => {
    const updateNum = (field, value) => {
        const num = value === '' ? 0 : parseFloat(value);
        onUpdate(field, isNaN(num) ? 0 : num);
    };

    const isModified = (field) => defaults && globals[field] !== defaults[field];

    return (
        <div className="gvb-bar">
            <div className="gvb-control">
                <label className="gvb-label">Interest Rate</label>
                <div className="gvb-slider-group">
                    <input
                        type="range"
                        min="2"
                        max="12"
                        step="0.01"
                        value={globals.interestRate}
                        onChange={e => updateNum('interestRate', e.target.value)}
                        className="gvb-slider"
                    />
                    <div className={`gvb-inline-input${isModified('interestRate') ? ' modified' : ''}`}>
                        <input
                            type="number"
                            step="0.01"
                            value={globals.interestRate || ''}
                            onChange={e => updateNum('interestRate', e.target.value)}
                        />
                        <span>%</span>
                    </div>
                </div>
            </div>

            <div className="gvb-control">
                <label className="gvb-label">Down Payment</label>
                <div className="gvb-dp-row">
                    <select
                        className={`gvb-select${isModified('downPaymentPercent') ? ' modified' : ''}`}
                        value={[5, 10, 15, 20, 25, 30].includes(globals.downPaymentPercent) ? globals.downPaymentPercent : ''}
                        onChange={e => updateNum('downPaymentPercent', e.target.value)}
                    >
                        <option value="" disabled hidden>Custom</option>
                        <option value={5}>5%</option>
                        <option value={10}>10%</option>
                        <option value={15}>15%</option>
                        <option value={20}>20%</option>
                        <option value={25}>25%</option>
                        <option value={30}>30%</option>
                    </select>
                    <div className={`gvb-inline-input${isModified('downPaymentPercent') ? ' modified' : ''}`}>
                        <input
                            type="number"
                            min="0"
                            max="100"
                            value={globals.downPaymentPercent || ''}
                            onChange={e => updateNum('downPaymentPercent', e.target.value)}
                        />
                        <span>%</span>
                    </div>
                </div>
            </div>

            <div className="gvb-control">
                <label className="gvb-label">Vacancy</label>
                <div className={`gvb-inline-input${isModified('vacancyRate') ? ' modified' : ''}`}>
                    <input
                        type="number"
                        min="0"
                        max="100"
                        value={globals.vacancyRate || ''}
                        onChange={e => updateNum('vacancyRate', e.target.value)}
                    />
                    <span>%</span>
                </div>
            </div>

            <div className="gvb-control">
                <label className="gvb-label">Appreciation</label>
                <div className={`gvb-inline-input${isModified('appreciationRate') ? ' modified' : ''}`}>
                    <input
                        type="number"
                        step="0.1"
                        value={globals.appreciationRate || ''}
                        onChange={e => updateNum('appreciationRate', e.target.value)}
                    />
                    <span>%/yr</span>
                </div>
            </div>

            <div className="gvb-control">
                <label className="gvb-label">DIY</label>
                <label className={`gvb-toggle${isModified('isDIY') ? ' modified' : ''}`}>
                    <input
                        type="checkbox"
                        checked={globals.isDIY || false}
                        onChange={e => onUpdate('isDIY', e.target.checked)}
                    />
                    <span className="gvb-toggle-slider" />
                </label>
            </div>
        </div>
    );
};

export default GlobalVariablesBar;
